// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nH5[data-v-15abd01c] {\r\n    margin-bottom: 8px;\n}\nP[data-v-15abd01c] {\r\n    margin-bottom: 8px;\n}\n.project DIV.q-card__section[data-v-15abd01c] {\r\n    padding: 8px;\n}\nSPAN.date[data-v-15abd01c] {\r\n    display: inline-block;\r\n    font-style: italic;\r\n    padding-left: 8px;\n}\nA.img-link[data-v-15abd01c] {\r\n    color: transparent;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
